<template>
  <table id="tabCluster">
    <tr class='trTitle'>
      <th class="desc-title">{{ $t("message.desc") }}</th>
      <th class="device-title">{{ $t("message.device") }}</th>
      <th class="qty-title"></th>
    </tr>
    <tr>
      <td class="headTd">{{title}}</td>
      <td class="headTd" colspan="2">PRA-MPS3</td>
    </tr>
    <tr>
      <td></td>
      <td class="device-content">{{ $t("message.mpsActiveEthernet") }}</td>
      <td class="qty-content">
        <input type="number" class="form-control form-control-sm" min=0 max=5
        v-model="ethernet" @change="inputValue()"/>
      </td>
    </tr>
    <tr>
      <td></td>
      <td class="device-content">{{ $t("message.mpsActiveSfp") }}</td>
      <td class="qty-content">
        <input type="number" class="form-control form-control-sm" min=0 max=1
        v-model="sfp" @change="inputValue()"/>
      </td>
    </tr>
    <tr class="wiersz-pusty"></tr>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PowerSupply',
  props: ['title', 'values', 'clear'],
  data () {
    return {
      ethernet: 0,
      sfp: 0
    }
  },
  watch: {
    clearing (newValue, oldValue) {
      if (newValue === true) {
        this.ethernet = 0
        this.sfp = 0
      }
    },
    clear (newValue, oldValue) {
      if (newValue === true) {
        this.ethernet = 0
        this.sfp = 0
      }
    },
    values (newValue, oldValue) {
      if (newValue !== null) {
        this.ethernet = this.values.ethernet
        this.sfp = this.values.sfp
      }
    }
  },
  computed: {
    ...mapGetters('app', ['clearing'])
  },
  methods: {
    inputValue () {
      this.$emit('allValues', this.ethernet, this.sfp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Devices/PowerSupply.vue